import React, {Dispatch, ReactNode, SetStateAction} from "react";
import {Dialog, DialogContent, DialogProps, DialogTitle} from "@material-ui/core";

interface IModalProps extends Pick<DialogProps, 'open' | 'maxWidth' | 'disableEscapeKeyDown'> {
    title?: string;
    closeModal: Dispatch<SetStateAction<boolean>>;
    children?: ReactNode;
    padding?: string;
}

const Modal: React.FC<IModalProps> = ({
                          title = 'Título do Modal Aqui',
                          open = true,
                          closeModal = () => {},
                          maxWidth = 'lg',
                          disableEscapeKeyDown = true,
                          children,
                          padding = '12px'
                      }) => {
    return (<Dialog
        open={open}
        onClose={closeModal}
        fullWidth={true}
        disableEscapeKeyDown={disableEscapeKeyDown}
        maxWidth={maxWidth}
    >
        <DialogTitle style={{textTransform: 'uppercase'}}>
            {title}
        </DialogTitle>
        <DialogContent style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', padding: padding, overflowX: 'auto'}}>
            <div style={{ width: '100%' }}>
                {children}
            </div>
        </DialogContent>
    </Dialog>);
}

export default Modal;